import styled from "styled-components";



export const DashBoardMainDiv=styled.div`
position: fixed;
top: 0;
left: 0;
right: 0;
bottom: 0;
width:100%;
height:100vh;
background: #0a0a0f;
background-image: 
  radial-gradient(circle at 20% 50%, rgba(120, 40, 200, 0.13) 0%, transparent 50%),
  radial-gradient(circle at 80% 80%, rgba(224, 5, 255, 0.13) 0%, transparent 50%),
  radial-gradient(circle at 40% 20%, rgba(167, 60, 255, 0.1) 0%, transparent 50%);
display:flex;
box-sizing: border-box;
overflow-y: auto;
overflow-x: hidden;

`;